module.exports = __webpack_public_path__ + "static/media/pt_paypal.6a556444.svg";